
import { useNavigate } from "react-router-dom";

import moment from "moment";
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from "primereact/inputtext";
import { Messages } from 'primereact/messages';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from "react";
import { Link } from 'react-router-dom';
import view_day_ar from "../functions/view_day_ar";
import { useWhatsapp } from '../whatsapp/WhatsappContext';
import { RESORT_NAME_EN, SHORT_RESORT_NAME } from './user';
import { _endPoints } from "./links";
import API from "./server/API";
import { InvoiceContext } from '../bookings/invoice/Invoice_Context';
import InvoiceCustomer from '../bookings/invoice/invoice_customer';
import ServiceReceiptMini from '../booking-services/invoice/ServiceReceiptMini';
import InvoiceBookinges from "../bookings/invoice/invoice_bookinges";
import { SelectButton } from 'primereact/selectbutton';
import { ProgressSpinner } from 'primereact/progressspinner';
import PayReservations from '../bookings/payments/pay_reservation';
import { Tag } from 'primereact/tag';
import { TabView, TabPanel } from 'primereact/tabview';
const USERNAME = window.localStorage.getItem('username');

function Sidebar() {
    const Navigate = useNavigate();
    const toast = useRef(null);
    const { loading_whatsapp, msgs } = useWhatsapp();
    const logOutUser = (e) => {
        e.preventDefault();
        Navigate("/logout")
    }
    const [whate_search, set_whate_search] = useState({ label: "حجز", value: "reservation" })
    const [openIndex, setOpenIndex] = useState(null);
    const [mysidebar, set_mysidebar] = useState([])
    const [loding1, set_loding1] = useState(true)
    const [viewQrDialog, set_viewQrDialog] = useState(false);
    const [qrCodeVal, setQrCodeVal] = useState("");
    const [loadingQr, setLoadingQr] = useState(false);
    const [qrReservationData, setQrReservationData] = useState(null);
    const [scannerRef, setScannerRef] = useState(null);
    const [qrActiveTab, setQrActiveTab] = useState(0);

    const [Invoice, setInvoice] = useState(false);
    const [ViewPaid, setViewPaid] = useState(false);
    const [InvoicePaid, setInvoicePaid] = useState(false);
    const [dataPaid, setDataPaid] = useState(null);

    const [viewChangePasswordDialog, setViewChangePasswordDialog] = useState(false);
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [loadingChangePassword, setLoadingChangePassword] = useState(false);

    const handleSaveNewPassword = async () => {
        if (!oldPassword || !newPassword || !confirmPassword) {
            toast.current.show({
                style: { fontFamily: "Cairo", fontSize: "1.2rem" },
                life: 3000,
                severity: 'warn', summary: 'تنبيه', detail: 'الرجاء ملء جميع الحقول'
            });
            return;
        }
        if (newPassword.length < 8) {
            toast.current.show({
                style: { fontFamily: "Cairo", fontSize: "1.2rem" },
                life: 3000,
                severity: 'warn', summary: 'تنبيه', detail: 'يجب أن تكون كلمة المرور الجديدة 8 أحرف على الأقل'
            });
            return;
        }
        if (newPassword !== confirmPassword) {
            toast.current.show({
                style: { fontFamily: "Cairo", fontSize: "1.2rem" },
                life: 3000,
                severity: 'warn', summary: 'تنبيه', detail: 'كلمة المرور الجديدة وتأكيدها غير متطابقتين'
            });
            return;
        }

        setLoadingChangePassword(true);
        try {
            const response = await API.post(_endPoints.users.change_password, {
                old_password: oldPassword,
                new_password: newPassword,
                confirm_password: confirmPassword
            });

            if (response?.success === 1) {
                toast.current.show({
                    style: { fontFamily: "Cairo", fontSize: "1.2rem" },
                    life: 3000,
                    severity: 'success', summary: 'نجاح', detail: response.msg || 'تم تغيير كلمة المرور بنجاح'
                });

                setViewChangePasswordDialog(false);
                setOldPassword("");
                setNewPassword("");
                setConfirmPassword("");
            } else {
                toast.current.show({
                    style: { fontFamily: "Cairo", fontSize: "1.2rem" },
                    life: 3000,
                    severity: 'error', summary: 'خطأ', detail: response?.msg || 'فشل تغيير كلمة المرور'
                });
            }
        } catch (error) {
            toast.current.show({
                style: { fontFamily: "Cairo", fontSize: "1.2rem" },
                life: 3000,
                severity: 'error', summary: 'خطأ', detail: 'حدث خطأ فني أثناء تغيير كلمة المرور'
            });
        }
        setLoadingChangePassword(false);
    };

    const getMySidebar = async () => {
        set_loding1(true);
        const response = await API.get(_endPoints.permissions.my);
        if (response?.success == 1) {
            set_mysidebar(response.data);
        }
        else if (response?.error == 1) {
            toast.current.show({
                style: {
                    fontFamily: "Cairo",
                    fontSize: "1.2rem"
                },
                life: 5000,
                severity: 'error', summary: 'خطــاء', detail: response?.msg
            });
        }
        set_loding1(false);
    }

    const searchQrCode = async (code) => {
        if (!code) return;
        setLoadingQr(true);
        const response = await API.get(_endPoints.reservations.get_by_qrcode + "?qrcode=" + code + "&search=" + whate_search);
        if (response?.success === 1) {
            setQrCodeVal("");
            set_viewQrDialog(false)
            if (response?.data?.date_del_reservation || response?.data?.total_price != response?.data?.total_paid) {
                setQrReservationData(response.data);
                setViewPaid(true)
            } else {
                setDataPaid({
                    customer: {
                        ID_customer: response?.data?.ID_customer,
                        visitor_name: response?.data?.visitor_name,
                        phone_number: response?.data?.phone_number,
                        whatsapp_number: response?.data?.whatsapp_number,
                        reservationes: [response?.data],
                    },
                })
                setInvoice(true)
            }
            if (scannerRef) {
                setScannerRef(null);
            }
        } else {
            // toast.current.clear()
            toast.current.show({
                style: { fontFamily: "Cairo", fontSize: "1.2rem" },
                life: 3000,
                severity: 'error', summary: 'خطــاء', detail: response?.msg || 'لم يتم العثور على الحجز'
            });
            setQrCodeVal("");

            setQrReservationData(null);
        }
        setLoadingQr(false);
    };

    const handleQrSearch = (e) => {
        if (e) e.preventDefault();
        searchQrCode(qrCodeVal);
    };

    useEffect(() => {
        let html5QrcodeScanner;
        if (viewQrDialog && qrActiveTab === 1 && !qrReservationData) {
            const timer = setTimeout(() => {
                if (window.Html5QrcodeScanner && document.getElementById("reader") && !document.getElementById("reader").innerHTML) {
                    html5QrcodeScanner = new window.Html5QrcodeScanner(
                        "reader",
                        { fps: 10, qrbox: { width: 250, height: 250 } },
                        false
                    );
                    html5QrcodeScanner.render((decodedText) => {
                        setQrCodeVal(decodedText);
                        searchQrCode(decodedText);
                    }, (errorMessage) => {
                        // ignore scan errors (they happen repeatedly while scanning)
                    });
                    setScannerRef(html5QrcodeScanner);
                }
            }, 300);

            return () => {
                clearTimeout(timer);
                if (html5QrcodeScanner) {
                    html5QrcodeScanner.clear().catch(error => {
                        console.error("Failed to clear html5QrcodeScanner. ", error);
                    });
                }
                setScannerRef(null);
            };
        }
    }, [viewQrDialog, qrActiveTab, qrReservationData]);

    useEffect(() => {
        getMySidebar();

    }, []);

    return (
        <>
            <Toast ref={toast} position="top-center" style={{ margin: "0 1rem 0 0 !important", fontFamily: "Cairo" }} remove />
            <header className="header" >
                <div className="page-brand">
                    <span className="brand pr-5" >{RESORT_NAME_EN}
                        {/* <span className="brand-tip"></span> */}
                    </span>
                    <span className="brand-mini" >{SHORT_RESORT_NAME}</span>
                </div>

                <div className="flexbox flex-1">
                    <ul className="nav navbar-toolbar">
                        <li>
                            <a className="nav-link sidebar-toggler js-sidebar-toggler" ><i className="ti-menu"></i></a>
                        </li>
                        {
                            window.innerWidth > 1230 ?
                                <>
                                    <li dir="rtl" className="pr-4" >
                                        <InputText value={`${view_day_ar(new Date())} / ${moment(new Date()).format("DD-MM-YYYY").toString()}`} disabled style={{ color: "black", fontWeight: "bold" }}></InputText>
                                    </li>
                                    <li dir="ltr" className="pr-2">
                                        <Button size="large" onClick={() => { set_viewQrDialog(true); setQrCodeVal(""); setQrReservationData(null); setQrActiveTab(0); }} label={<i className="fa fa-qrcode"></i>} severity="info" outlined />
                                    </li>
                                    <li dir="ltr" className="pr-2">
                                        <Button size="large" label={<i className="pi pi-whatsapp"></i>} severity="success" outlined loading={loading_whatsapp} />
                                    </li>
                                    <li dir="rtl" className="pr-1" >
                                        <Messages ref={msgs} />
                                    </li>
                                </>
                                : null
                        }
                    </ul>

                    {
                        window.innerWidth <= 1230 ?
                            <>
                                <ul className="nav navbar-toolbar ">
                                    <li dir="ltr" className="pr-2">
                                        <Button size="large" onClick={() => { set_viewQrDialog(true); setQrCodeVal(""); setQrReservationData(null); setQrActiveTab(0); }} label={<i className="fa fa-qrcode"></i>} severity="info" outlined />
                                    </li>
                                    <li dir="ltr" >
                                        <Button size="large" label={<i className="pi pi-whatsapp"></i>} severity="success" outlined loading={loading_whatsapp} />
                                    </li>
                                </ul>
                                <ul className="nav navbar-toolba pr-1">
                                    <li dir="ltr" >
                                        <Messages ref={msgs} style={{ fontSize: ".5rem" }} className="pr-0 mr-0" />
                                    </li>
                                </ul>
                            </>
                            :
                            <>

                            </>
                    }

                    {/* <Tag severity="danger" className="pr-4 pl-4 pb-1 pt-1 pb-1" >
                        <h5 className="font-bold">وضع الاختبار</h5>
                    </Tag> */}



                    <ul className="nav navbar-toolbar">


                        {/* <li className="dropdown dropdown-notification">
                        <a className="nav-link dropdown-toggle" data-toggle="dropdown"><i className="fa fa-bell-o rel"><span className="notify-signal"></span></i></a>
                        <ul className="dropdown-menu dropdown-menu-right dropdown-menu-media">
                            <li className="dropdown-menu-header">
                                <div>
                                    <span><strong>5 New</strong> Notifications</span>
                                    <a className="pull-right" href="javascript:;">view all</a>
                                </div>
                            </li>
                            <li className="list-group list-group-divider scroller" data-height="240px" data-color="#71808f">
                                <div>
                                    <a className="list-group-item">
                                        <div className="media">
                                            <div className="media-img">
                                                <span className="badge badge-success badge-big"><i className="fa fa-check"></i></span>
                                            </div>
                                            <div className="media-body">
                                                <div className="font-13">4 task compiled</div><small className="text-muted">22 mins</small></div>
                                        </div>
                                    </a>
                                    <a className="list-group-item">
                                        <div className="media">
                                            <div className="media-img">
                                                <span className="badge badge-default badge-big"><i className="fa fa-shopping-basket"></i></span>
                                            </div>
                                            <div className="media-body">
                                                <div className="font-13">You have 12 new orders</div><small className="text-muted">40 mins</small></div>
                                        </div>
                                    </a>
                                    <a className="list-group-item">
                                        <div className="media">
                                            <div className="media-img">
                                                <span className="badge badge-danger badge-big"><i className="fa fa-bolt"></i></span>
                                            </div>
                                            <div className="media-body">
                                                <div className="font-13">Server #7 rebooted</div><small className="text-muted">2 hrs</small></div>
                                        </div>
                                    </a>
                                    <a className="list-group-item">
                                        <div className="media">
                                            <div className="media-img">
                                                <span className="badge badge-success badge-big"><i className="fa fa-user"></i></span>
                                            </div>
                                            <div className="media-body">
                                                <div className="font-13">New user registered</div><small className="text-muted">2 hrs</small></div>
                                        </div>
                                    </a>
                                </div>
                            </li>
                        </ul>
                    </li> */}
                        <li className="dropdown dropdown-user">
                            <a className="nav-link dropdown-toggle link" data-toggle="dropdown" href='#user'>
                                <i className="pi pi-user pl-2"></i>
                                {
                                    window.innerWidth <= 1230 ?
                                        null
                                        :
                                        <>
                                            {USERNAME}
                                        </>
                                }
                            </a>
                            <ul className="dropdown-menu" style={{ textAlign: "center" }}>
                                <a className="dropdown-item" onClick={(e) => { e.preventDefault(); setViewChangePasswordDialog(true); }} href='#change-password'><i className="pi pi-key pl-2" style={{ fontSize: '1rem', verticalAlign: 'middle' }}></i> تغيير كلمة المرور </a>
                                <a className="dropdown-item" onClick={(e) => logOutUser(e)} href='#user'><i className="fa fa-sign-out"></i> تسجيل خروج  </a>
                            </ul>
                        </li>

                    </ul>
                </div>

            </header>

            <nav className="page-sidebar" id="sidebar">
                <div id="sidebar-collapse">
                    <div className="admin-block d-flex">
                        <center>
                            <img src="./assets/img/logo.png" alt='logo' width="50%" />
                        </center>
                    </div>
                    <ul className="side-menu metismenu" id="side-menu">
                        <li>
                            <Link to="/" >
                                <i className="sidebar-item-icon fa fa-th-large"></i>
                                <span className="nav-label">الرئسية</span>
                            </Link>
                        </li>

                        {mysidebar?.map((item, key) => {
                            const collapseId = `menu-${key}`;
                            return (
                                <React.Fragment key={key}>
                                    <hr
                                        style={{
                                            backgroundColor: "rgba(255, 255, 255, .4)",
                                            width: "90%"
                                        }}
                                    />
                                    {
                                        item.to ?
                                            <li>
                                                <Link to={item.to} >
                                                    <i className={item.icon} style={{ fontSize: "1.5rem" }}></i>
                                                    <span className="nav-label">{item.label}</span>
                                                </Link>
                                            </li>
                                            :
                                            <li>
                                                <a
                                                    href={`#${collapseId}`}
                                                    data-toggle="collapse"
                                                    data-parent="#side-menu"
                                                >
                                                    <i className={item.icon}></i>
                                                    <span className="nav-label">{item.label}</span>
                                                </a>

                                                {item?.items?.length > 0 && (
                                                    <ul
                                                        id={collapseId}
                                                        className="nav-2-level collapse"
                                                    >
                                                        {item.items.map((sub, i) => (
                                                            <li key={i} style={{ backgroundColor: "#2e4255" }} >
                                                                <Link to={sub.to}>
                                                                    <span className="nav-label">
                                                                        {sub.label}
                                                                    </span>
                                                                </Link>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}
                                            </li>
                                    }
                                </React.Fragment>
                            );
                        })}
                        <hr style={{ backgroundColor: "rgba(255, 255, 255, .4)", width: "90%" }} />
                        {/* <li>
                            <Link to="/admin-dashboard">
                                <i className="sidebar-item-icon fa fa-bar-chart" style={{ fontSize: "1.5rem", color: "#e74c3c" }}></i>
                                <span className="nav-label">لوحة التحكم الإحصائية</span>
                            </Link>
                        </li>
                        <li>
                            <Link to="/service-dashboard">
                                <i className="sidebar-item-icon fa fa-dashboard" style={{ fontSize: "1.5rem", color: "#3498db" }}></i>
                                <span className="nav-label">لوحة تحكم العمليات</span>
                            </Link>
                        </li>
                        <li>
                            <Link to="/users-app-active">
                                <i className="sidebar-item-icon fa fa-bolt" style={{ fontSize: "1.5rem", color: "#28a745" }}></i>
                                <span className="nav-label">المتصلين الآن</span>
                            </Link>
                        </li> */}
                        {/* <hr style={{backgroundColor:"rgba(255, 255, 255, .4)",width:"90%",textAlign:"center"}}></hr>
                        <li>
                            <a href="#revss"><i className="sidebar-item-icon fa fa-calendar"></i>
                                <span className="nav-label">إدارة الحجز</span>
                            </a>
                            <ul className="nav-2-level collapse">
                                <li>
                                    <Link to="/booking" >
                                        <span className="nav-label">حجز جديد</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/bookings" >
                                        <span className="nav-label">حجوزات</span>
                                    </Link>
                                </li>
                            </ul>
                        </li> */}

                        {/* <hr style={{backgroundColor:"rgba(255, 255, 255, .4)",width:"90%",textAlign:"center"}}></hr>
                        <li>
                            <a href="#rev"><i className="sidebar-item-icon fa fa-users"></i>
                                <span className="nav-label">إدارة العملاء</span>
                            </a>
                            <ul className="nav-2-level collapse">
                                <li>
                                    <Link to="/customer-new" >
                                        <span className="nav-label">عميل جديد</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/customers" >
                                        <span className="nav-label">عملاء</span>
                                    </Link>
                                </li>
                            </ul>
                        </li> */}
                        {/* <hr style={{backgroundColor:"rgba(255, 255, 255, .4)",width:"90%",textAlign:"center"}}></hr>
                        <li>
                            <a href="#pay"><i className="sidebar-item-icon fa fa-money"></i>
                                <span className="nav-label">إدارة المالية</span>
                            </a>
                            <ul className="nav-2-level collapse">
                            <li>
                                <Link to="/payments-day" >
                                    <span className="nav-label">مدفوعات يومية</span>
                                </Link>
                                <Link to="/payments-month" >
                                    <span className="nav-label">مدفوعات شهرية</span>
                                </Link>
                                <Link to="/payments-year" >
                                    <span className="nav-label">مدفوعات سنوية</span>
                                </Link>
                            </li>
                            </ul>
                        </li>
                        <hr style={{backgroundColor:"rgba(255, 255, 255, .4)",width:"90%",textAlign:"center"}}></hr>
                        <li>
                            <a href="#reports"><i className="sidebar-item-icon fa fa-file"></i>
                                <span className="nav-label">إدارة التقارير</span>
                            </a>
                            <ul className="nav-2-level collapse">
                            <li>
                                <Link to="/report_bookinges" >
                                    <span className="nav-label">تقرير الحجوزات</span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/report-check" >
                                    <span className="nav-label">تقرير الاستلام والمغادرة</span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/report-reservationes" >
                                    <span className="nav-label">تقرير الحجوزات والمدفوعات</span>
                                </Link>
                            </li>
                            </ul>
                        </li>
                        <hr style={{backgroundColor:"rgba(255, 255, 255, .4)",width:"90%",textAlign:"center"}}></hr>
                        <li>
                            <Link to="/apartments" >
                                <i className="sidebar-item-icon fa fa-home" style={{fontSize:"1.5rem"}}></i>
                                <span className="nav-label">إدارة الإقـامات</span>
                            </Link>
                        </li>
                        <hr style={{backgroundColor:"rgba(255, 255, 255, .4)",width:"90%",textAlign:"center"}}></hr>

                        <li>
                            <a href="#users"><i className="sidebar-item-icon fa fa-user"></i>
                                <span className="nav-label">إدارة المستخدمين</span>
                            </a>
                            <ul className="nav-2-level collapse">
                                <li>
                                    <Link to="/users" >
                                        <span className="nav-label">المستخدمين</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/users" >
                                        <span className="nav-label">تتبع المستخدمين</span>
                                    </Link>
                                </li>
                            </ul>
                        </li> */}
                    </ul>
                </div>
            </nav>

            <Dialog dir="rtl" header="إيصال قبض" visible={ViewPaid} maximizable style={{ width: '60vw', fontFamily: "Cairo" }} onHide={() => setViewPaid(false)} maximized={window.innerWidth <= 1230 ? true : false}>

                {qrReservationData && (
                    <InvoiceContext.Provider value={[qrReservationData]}>
                        <InvoiceContext.Provider value={
                            {
                                customer: {
                                    ID_customer: qrReservationData?.ID_customer,
                                    visitor_name: qrReservationData?.visitor_name,
                                    phone_number: qrReservationData?.phone_number,
                                    whatsapp_number: qrReservationData?.whatsapp_number,
                                },
                                "reservations": [qrReservationData],
                                "setViewPaid": setViewPaid,
                                "GetReservationesComing": () => { },
                                "GetReservationesNow": () => { },
                                "GetReservationesOld": () => { },
                                "setSelectedReservationes": () => { },
                                "setDataPaid": setDataPaid,
                                "setInvoicePaid": setInvoice,
                                "toast": toast,
                            }
                        } >

                            <PayReservations></PayReservations>

                        </InvoiceContext.Provider>
                    </InvoiceContext.Provider>
                )}
            </Dialog>


            <Dialog dir="rtl" header="فاتورة الحجوزات" visible={Invoice} maximizable style={{ width: 'auto', fontFamily: "Cairo", minHeight: "100vh" }} onHide={() => setInvoice(false)} maximized={window.innerWidth <= 1230 ? true : false}
                footer={
                    <center>
                        <hr></hr>
                        <Button label="إغلاق" icon="pi pi-times" onClick={() => setInvoice(false)} severity="danger" outlined />
                    </center>
                }
            >
                {
                    (dataPaid?.reservationes?.length == 1 && dataPaid?.reservationes[0]?.reservation_type == 'service')
                        ||
                        (dataPaid?.customer?.reservationes?.length == 1 && dataPaid?.customer?.reservationes[0]?.reservation_type == 'service')

                        ?
                        <ServiceReceiptMini
                            bookingData={dataPaid?.customer?.reservationes?.length > 0 ? dataPaid?.customer?.reservationes[0] : null}
                            customerData={dataPaid?.customer}
                            reservationData={dataPaid?.customer?.reservationes?.length > 0 ? dataPaid?.customer?.reservationes[0] : null}
                        />
                        :
                        <InvoiceContext.Provider value={dataPaid?.customer?.reservationes?.length > 0 ? dataPaid?.customer?.reservationes : dataPaid?.reservationes?.length > 0 ? dataPaid.reservationes : []} >
                            <InvoiceBookinges></InvoiceBookinges>
                        </InvoiceContext.Provider>
                }
            </Dialog>


            <Dialog
                header="قارئ رموز الـ QR ( الحجوزات - أسوار )"
                visible={viewQrDialog}
                style={{ width: '50vw', height: "auto", fontFamily: "Cairo" }}
                maximizable maximized={window.innerWidth <= 1230 ? true : false}
                onHide={() => { set_viewQrDialog(false); setQrReservationData(null); }}
                dir="rtl"
                footer={
                    <center>
                        <Button className="" label="إغـلاق" severity="danger" outlined
                            onClickCapture={(e) => set_viewQrDialog(false)}
                        />
                    </center>
                }>
                <div className="p-fluid">
                    <TabView activeIndex={qrActiveTab} onTabChange={(e) => setQrActiveTab(e.index)} style={{ fontFamily: "Cairo" }}>
                        <TabPanel header="إدخال يدوي / قارئ الرمز" leftIcon="pi pi-keyboard pl-2">
                            <div className="card p-4">
                                <div className="row">
                                    <div className="col-md-4 mb-4">
                                        <label id='lfamily_type'>البحـث عـن * </label>
                                        <SelectButton value={whate_search} onChange={(e) => set_whate_search(e.value)} options={[{ label: "حجز", value: "reservation" }, { label: "أسوار", value: "reservation_bracelets" }]} optionLabel="label"
                                            itemTemplate={(item) => {
                                                return <center>{item?.label}</center>
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-8 mb-4">
                                        <label htmlFor="qrcode">امسح الرمز بواسطة القارئ أو أدخله يدوياً:</label>
                                        <InputText
                                            id="qrcode"
                                            value={qrCodeVal}
                                            onChange={(e) => setQrCodeVal(e.target.value)}
                                            autoFocus
                                            onKeyDown={(e) => { if (e.key === 'Enter') handleQrSearch(e); }}
                                            placeholder="QR Code..." className="col-md-10 col-10"
                                            disabled={loadingQr}
                                        />
                                        <Button icon="pi pi-search" outlined onClick={handleQrSearch} loading={loadingQr} autoFocus />
                                    </div>
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel header="كاميرا القارئ" leftIcon="pi pi-camera pl-2">
                            <div className="card p-4">
                                <div className="row">
                                    <div className="col-md-4 mb-4">
                                        <label id='lfamily_type'>البحـث عـن * </label>
                                        <SelectButton value={whate_search} onChange={(e) => set_whate_search(e.value)} options={[{ label: "حجز", value: "reservation" }, { label: "أسوار", value: "reservation_bracelets" }]} optionLabel="label"
                                            itemTemplate={(item) => {
                                                return <center>{item?.label}</center>
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-8 mb-4">
                                        {loadingQr && (
                                            <center>
                                                <br />
                                                <ProgressSpinner strokeWidth="3" animationDuration="1s" style={{ width: '50px', height: '50px' }} />
                                                <h6 className="mt-2" style={{ fontFamily: "Cairo" }}>جاري البحث...</h6>
                                            </center>
                                        )}
                                        <div id="reader" style={{ width: '100%', display: qrReservationData || loadingQr ? 'none' : 'block' }}></div>
                                    </div>
                                </div>
                            </div>
                        </TabPanel>
                    </TabView>
                </div>

                {/* </div> */}

                <div className="card" style={{ height: "auto" }}>
                    {
                        loadingQr ?

                            <center>
                                <br /><br />
                                <ProgressSpinner strokeWidth="3" animationDuration="1s" />
                            </center>
                            :
                            <></>
                    }
                </div>
            </Dialog>

            <Dialog
                header="تغيير كلمة المرور"
                visible={viewChangePasswordDialog}
                style={{ width: window.innerWidth <= 1230 ? '90vw' : '30vw', fontFamily: "Cairo" }}
                onHide={() => {
                    setViewChangePasswordDialog(false);
                    setOldPassword("");
                    setNewPassword("");
                    setConfirmPassword("");
                }}
                dir="rtl"
                footer={
                    <center>
                        <Button label="حفظ" severity="success" onClick={handleSaveNewPassword} loading={loadingChangePassword} />
                        <Button label="إلغاء" severity="danger" outlined onClick={() => setViewChangePasswordDialog(false)} />
                    </center>
                }
            >
                <div className="p-fluid">
                    <div className="mb-3">
                        <label htmlFor="old_password">كلمة المرور الحالية</label>
                        <InputText
                            id="old_password"
                            type="password"
                            value={oldPassword}
                            onChange={(e) => setOldPassword(e.target.value)}
                            placeholder="أدخل كلمة المرور الحالية"
                        />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="new_password">كلمة المرور الجديدة</label>
                        <InputText
                            id="new_password"
                            type="password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            placeholder="أدخل كلمة المرور الجديدة (8 أحرف على الأقل)"
                        />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="confirm_password">تأكيد كلمة المرور الجديدة</label>
                        <InputText
                            id="confirm_password"
                            type="password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            placeholder="أعد إدخال كلمة المرور الجديدة"
                        />
                    </div>
                </div>
            </Dialog>
        </>

    )
}

export default Sidebar


